import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Row, Col, Button, Form, Badge } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import DeviceService, { DeviceItem } from '#/services/DeviceService';
import MapView from './parts/MapView';
import { UserContext } from './App';
import { SpinnerView } from './parts/SpinnerView';

function ChildModify() {
  const ctx = useContext(UserContext);
  const [owners, setOwners] = useState<DeviceItem[]>();
  const [device, setDevice] = useState<Partial<DeviceItem>>();
  const { control, handleSubmit } = useForm();
  const { id } = useParams();
  const service = new DeviceService('child', ctx.userInfo!);
  const navigate = useNavigate();

  useEffect(() => {
    new DeviceService('owner', ctx.userInfo!).getList({ page: 0 }).then(
      (res) => {
        setOwners(res.data || []);
      },
      (e) => {
        if (e?.response.status === 401) {
          navigate(0);
        }
      }
    );

    if (id) {
      service.getInfo(id!).then(
        (data) => {
          setDevice(data);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    } else {
      setDevice({
        name: '',
        device_id: '',
        owner_id: '',
        location: {
          lat: 35.123,
          lon: 135.334,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFieldChange = useCallback(
    (value) => {
      setDevice({
        ...device!,
        ...value,
      });
    },
    [device]
  );

  const onLocationChange = (lat: number, lon: number) => {
    setDevice({
      ...device!,
      location: {
        lat,
        lon,
      },
    });
  };

  const onSubmit = (values: { [key: string]: any }) => {
    const owner = owners!.find((owner) => owner.id === values.owner_id);

    if (id !== undefined) {
      service
        .modifyDevice({
          ...values,
          type: 'child',
          location: device!.location,
          admin_id: device!.admin_id,
          owner_id: device!.owner_id,
          id: Number(id),
        })
        .then((_) => {
          navigate('/child');
        });
    } else {
      service
        .addDevice({
          ...values,
          type: 'child',
          location: device!.location!,
          admin_id: owner?.admin_id,
          owner_id: device!.owner_id,
        })
        .then((_) => {
          // 一覧画面に遷移
          navigate('/child');
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
              <h1 className="page-header-title">
                子機登録
              </h1>
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row className="mt-3">
              <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <Badge pill bg="danger" className="me-2">
                        必須
                      </Badge>
                      親機識別ID
                    </Form.Label>
                    <Controller
                      control={control}
                      name="owner_id"
                      render={({ field: { onChange, ref, value } }) => (
                        <Form.Select
                          aria-label="親機識別ID"
                          onChange={(e) => {
                            onChange(e);
                            onFieldChange({ owner_id: e.target.value });
                          }}
                          value={device ? device!.owner_id : value || ''}
                          ref={ref}
                          disabled={!device || !owners}
                        >
                          <option></option>
                          {owners ? (
                            owners.map((owner) => {
                              return (
                                <option value={owner.id} key={owner.id}>
                                  {owner.device_id}
                                </option>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                      )}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <Badge pill bg="danger" className="me-2">
                        必須
                      </Badge>
                      子機識別ID
                    </Form.Label>
                    <Controller
                      control={control}
                      name="device_id"
                      render={({ field: { onChange, ref } }) => (
                        <Form.Control
                          type="edit"
                          onChange={(e) => {
                            onChange(e);
                            onFieldChange({ device_id: e.target.value });
                          }}
                          value={device ? device.device_id : ''}
                          ref={ref}
                          disabled={!device}
                        />
                      )}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>名称</Form.Label>
                    <Controller
                      control={control}
                      name="name"
                      render={({ field: { onChange, ref } }) => (
                        <Form.Control
                          type="edit"
                          onChange={(e) => {
                            onChange(e);
                            onFieldChange({ name: e.target.value });
                          }}
                          value={device ? device.name : ''}
                          ref={ref}
                          disabled={!device}
                        />
                      )}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>設定位置</Form.Label>
                    <div className="w-100" style={{ height: '500px' }}>
                      {device ? (
                        <MapView
                          {...device!.location!}
                          onChange={onLocationChange}
                        ></MapView>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Form.Group>
                  <Form.Group className="text-center">
                    <Controller
                      control={control}
                      name="name"
                      render={({ field: { ref }, formState }) => (
                        <Button
                          type="submit"
                          variant="primary"
                          className="w-50"
                          ref={ref}
                          disabled={formState.isSubmitting}
                        >
                          {formState.isSubmitting ? (
                            <SpinnerView />
                          ) : id ? (
                          '更新'
                          ) : (
                          '登録'
                          )}
                        </Button>
                      )}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChildModify;
